import * as React from "react";

import DeprecatedIconButton from "@v1/components/designSystem/button/IconButton";
import { CircleHelp } from "lucide-react";

export const HelpDocumentationIcon = () => (
  <DeprecatedIconButton
    tooltipText="Open Help Documentation"
    variant="secondary"
    size="base"
    layoutClassName="h-8 w-8"
    icon={<CircleHelp size={16} className="text-default" />}
    to="https://support.replo.app/articles/2069301880-experiments-(a/b-testing)"
    target="_blank"
    rel="noopener noreferrer"
  />
);
